import type { AppModule } from '@/shared/types';
import * as routes from '@/modules/auth/routes';

export const AuthModule: AppModule = {
  routes,
};
